export default __webpack_public_path__ + "static/media/bg-performance-1.8f491e35.png";